<template>
  <div>
    <page-title title="Testing" />
    <b-row>
      <b-col>
        <p>This page has some information to help simplify testing the application.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-html="formattedTextFunctionality"></div>
      </b-col>
      <b-col>
        <h2>Accounts</h2>
        <p>There are several accounts available for testing.</p>
        <table class="table">
          <tr>
            <th>Username</th>
            <th>Notes</th>
          </tr>
          <tr>
            <td>siteadmin</td>
            <td>Site Administrator: this user has access to everything</td>
          </tr>
          <tr>
            <td>station1head</td>
            <td>Station Head: this user has access to everything related to this station</td>
          </tr>
          <tr>
            <td>station1collector</td>
            <td>Station Collector: this user can provide allergen collection data for this station</td>
          </tr>
          <tr>
            <td>station1mynab</td>
            <td>Station My NAB User: this user has a subscription to this station</td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import marked from 'marked'

export default {
  name: 'Testing',
  props: {
  },
  data() {
    return {
      text: {
        functionality: `
## Functionality

All application functionality should be in place.
        `
      }
    }
  },  
  computed: {
    formattedTextFunctionality: function (key) {
      return marked(this.text.functionality, { sanitize: true })
    }
  }  
}
</script>